// extracted by mini-css-extract-plugin
export var iframe = "GoogleMapsEmbed-module--iframe--68f69";
export var wrapper = "GoogleMapsEmbed-module--wrapper--b22ec";